import React from "react";
import { Popover } from "web-ui";
import type { Direction } from "web-ui/dist/types/components/Popover";

import styles from "components/HintedContent.module.scss";

interface Props {
  children?: React.ReactNode;
  direction: Direction;
  offset?: number;
  shortText: string | React.ReactNode;
  zIndex: number;
}

const HintedContent = ({
  children,
  direction,
  offset,
  shortText,
  zIndex,
}: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={styles.wrap}>
      <div
        className={styles.inner}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {shortText}
      </div>
      {isOpen ? (
        <Popover direction={direction} offset={offset} zIndex={zIndex}>
          {children}
        </Popover>
      ) : null}
    </div>
  );
};

export default HintedContent;
